<template>
  <div class="manager_box">
    <div class="table_add">
      <div class="shuzhuang">
        <div
          :class="{ active: Tree_data_value == item }"
          v-for="(item, index) in Tree_data"
          :key="index"
          @click="handleNodeClick(item)"
        >
          {{ item }}
        </div>
      </div>
      <el-table
        :data="tableData"
        style="padding-left: 12px"
        v-loading="tableData_loading"
      >
        <el-table-column prop="realname" label="姓名"></el-table-column>
        <!-- <el-table-column prop="realname" label="性别" min-width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.gender == 1">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="100"></el-table-column>-->
        <el-table-column prop="username" label="账号"></el-table-column>
        <el-table-column
          prop="now_month_target"
          label="目标"
          v-if="Tree_data_value == '渠道'"
          :key="Math.random()"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.now_month_target }}</span>
            </div>
            <div v-else>
              <!-- <el-input-number v-model="B_category_input" @change="handleChange" :min="0" label="描述文字"></el-input-number> -->
              <el-input
                type="number"
                :min="0"
                v-model="now_month_mb"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="agent_target_money"
          label="代理商目标"
          v-if="$cookies.get('agent_company_name') == null"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{ scope.row.now_agent_month }}</span>
            </div>
            <div v-else>
              <!-- <el-input-number v-model="B_category_input" @change="handleChange" :min="0" label="描述文字"></el-input-number> -->
              <el-input
                type="number"
                :min="0"
                v-model="agent_target"
                placeholder="请输入代理商目标"
              ></el-input>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column
          class="target_setting_input"
          prop="nex_month_target"
          label="下月目标"
          min-width="100"
        >
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <span>{{scope.row.nex_month_target}}</span>
            </div>
            <div v-else>
              <el-input type="number" :min="0" v-model="next_month_mb" placeholder="请输入内容"></el-input>
            </div>
          </template>
        </el-table-column>-->
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <div v-if="tableData_id != scope.row.staff_id">
              <el-button
                @click="handleClick(scope.row)"
                type="primary"
                size="small"
                >编辑</el-button
              >
              <!-- <el-button type="danger" size="small">删除</el-button> -->
            </div>
            <div v-else>
              <el-button
                @click="preservation(scope.row)"
                type="warning"
                size="small"
                >保存</el-button
              >
              <el-button type="info" @click="cancel" size="small"
                >取消</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_div">
      <el-pagination
        hide-on-single-page
        background
        @current-change="handleCurrentChange"
        :page-size="15"
        :current-page="currentPage"
        layout="prev, pager, next, jumper"
        :total="user_count"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      tableData_loading: false, // 表格加载
      tableData: [], // 列表
      tableData_id: "", // 列表选中的ID
      user_count: 0, // 总页数
      now_month_mb: 0, // 这个月的目标
      next_month_mb: 0, // 下个月的目标，
      page: 0,
      agent_target: "",
      Tree_data: ["渠道", "24猎代理商"],
      Tree_data_value: "渠道",
      currentPage: 1,
    };
  },
  created() {
    this.lufish_user_list(this.page);
  },
  methods: {
    handleNodeClick(item) {
      console.log(item);
      this.Tree_data_value = item;
      // this.page = 0;
      this.currentPage = 1;
      this.lufish_user_list(this.page);
    },
    lufish_user_list(page) {
      // 目标列表
      this.tableData_loading = true;
      require("POST", "/lufish_sale/v1/show_target_list/", {
        filtration_product_name: this.Tree_data_value,
        page,
      }).then((res) => {
        console.log("目标列表", res);
        if (!res.code) {
          this.user_count = res.data.target_count;
          this.tableData = res.data.target_data;
        } else {
          this.$message.error("列表获取失败");
        }
        this.tableData_loading = false;
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // this.page = val - 1;
      this.currentPage = val;
      this.lufish_user_list(val - 1);
    },
    handleClick(e) {
      // 编辑
      console.log("当前编辑内容", e);
      this.tableData_id = e.staff_id;
      this.next_month_mb = e.nex_month_target;
      this.now_month_mb = e.now_month_target;
      this.now_agent_month = e.now_agent_month;
      this.agent_target = Number(e.now_agent_month);
    },
    preservation(e) {
      // 保存
      console.log("ID", e.staff_id);
      let that = this;
      if (this.Tree_data_value == "渠道" && this.now_month_mb === "") {
        this.$message.error("本月开拓目标有误");
        return false;
      }
      if (
        this.agent_target === "" &&
        this.$cookies.get("agent_company_name") == null
      ) {
        this.$message.error("本月代理商目标有误");
        return false;
      }
      this.tableData_loading = true;
      let obj = {};
      if (this.Tree_data_value == "渠道") {
        obj = {
          sale_people_id: e.staff_id,
          is_this_month: 1,
          target_money: that.now_month_mb,
          agent_target_money: that.agent_target,
        };
      } else {
        obj = {
          sale_people_id: e.staff_id,
          is_this_month: 1,
          agent_target_money: that.agent_target,
        };
      }
      require("POST", "/lufish_sale/v1/settings_sale_target/", obj).then(
        (res) => {
          if (!res.code) {
            e.now_agent_month = Number(that.agent_target);
            if (this.Tree_data_value == "渠道") {
              e.now_month_target = Number(that.now_month_mb);
            }
            that.tableData_id = "";
            that.$message({ message: "更新成功", type: "success" });
          } else {
            this.$message.error("更新失败");
          }
          this.tableData_loading = false;
        }
      );
    },
    // settings_sale_target(e) {
    //   console.log('ID', e)
    //   let that = this
    //   require("POST", "/lufish_sale/v1/settings_sale_target/", {
    //     sale_people_id: e.staff_id,
    //     is_this_month: 1,
    //     target_money: that.now_month_mb,
    //   }).then(res => {
    //     if (!res.code) {
    //       e.now_month_target = that.now_month_mb
    //       that.tableData_id = "";
    //       that.$message({ message: "更新成功", type: "success" });
    //     } else {
    //       this.$message.error("更新失败");
    //     }
    //     this.tableData_loading = false;
    //   });
    // },
    cancel() {
      this.tableData_id = "";
      console.log("取消保存");
    },
    handleChange(e) {
      // console.log('当前数', e)
    },
  },
};
</script>
<style scoped>
.table_add {
  /* border:1px red solid; */
  background: #f5f5f5;
  display: flex;
  min-height: 80vh;
}
.pagination_div {
  margin: 20px auto;
  text-align: center;
}
.shuzhuang {
  min-width: 200px;
  margin-right: 20px;
  background: white;
}
.shuzhuang > .active {
  color: rgb(44, 44, 44);
  background: rgba(115, 181, 246, 0.3);
  font-weight: bold;
}
.shuzhuang > div {
  width: 100%;
  background: #fff;
  line-height: 40px;
  text-align: center;
  /* border-bottom: #ccc solid 1px; */
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/target_setting.vue